import React from "react";
import { Switch, Redirect } from "react-router-dom";
import PrivateRoute from "../../components/PrivateRoute";
import routes from "./router";

function getAccessRoutes(routesArray, userPermissions) {
  const accessRoutes = [];

  const isAdminUser = userPermissions.sm_solution_access === true;

  routesArray.forEach((route) => {
    const hasPermission = Object.values(route.permission).some(
      (permission) => isAdminUser || userPermissions[permission],
    );

    if (hasPermission) {
      accessRoutes.push(...route.accessRoutes);
    }
  });
  return accessRoutes;
}

const PrivateSwitch = ({ permission }) => {
  const routesArray = getAccessRoutes(routes, permission);
  return (
    <Switch>
      {routesArray.length > 0 &&
        routesArray.map((prop, key) => {
          return (
            <PrivateRoute
              key={`index${key}`}
              path={prop.path}
              exact={prop.exact}
              component={prop.component}
              elementParams={prop.elementParams}
            />
          );
        })}
      <Redirect to="/" />
    </Switch>
  );
};

export default PrivateSwitch;
